import { useMemo } from 'react';
import { Box, CircleIcon, HStack } from 'native-base';
import { useTranslation } from 'react-i18next';

import { Text } from '@pimm/base';
import { EmpLearningPathStatusEnum } from '@pimm/services/lib/sms-workforce';

type BadgeStatusProps = {
  status: EmpLearningPathStatusEnum;
};

export const LearningPathBadge = ({ status }: BadgeStatusProps) => {
  const { t } = useTranslation();

  const { color, displayText } = useMemo(() => {
    const map: Record<EmpLearningPathStatusEnum, { color: string; displayText: string }> = {
      [EmpLearningPathStatusEnum.Pending]: { color: 'gray', displayText: 'app_insights:pending' },
      [EmpLearningPathStatusEnum.Enrolled]: { color: 'gray', displayText: 'app_insights:enrolled' },
      [EmpLearningPathStatusEnum.Started]: { color: 'warning', displayText: 'app_insights:started' },
      [EmpLearningPathStatusEnum.Complete]: { color: 'blueLight', displayText: 'app_insights:completed' },
    };
    return map[status ?? EmpLearningPathStatusEnum.Pending];
  }, [status]);

  return (
    <Box
      rounded="md"
      flex="none"
      justifyContent="center"
      py={0.5}
      px={1.5}
      h={5}
      borderWidth={1}
      borderColor={`${color}.200`}
      bg={`${color}.50`}
    >
      <Text size="sm" color={`${color}.700`}>
        {t(displayText)}
      </Text>
    </Box>
  );
};
